module.exports = __webpack_public_path__ + "static/media/nus_logo_full-vertical.a5ea317c.jpg";